import { EncodingElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Encoding extends EncodingElement {}
export default Encoding;